class Globe {
  constructor(globe) {
    const width = 960;
    const height = 500;
    const overlay = document.querySelector("#js-globe-overlay");
    const config = {
      speed: 0.01,
      verticalTilt: -30,
      horizontalTilt: 20,
      sensitivity: 75,
    };
    let userHasInteracted = false;
    let locations = [];
    const svg = d3
      .select(globe)
      .attr("width", width)
      .attr("height", height)
      .attr("preserveAspectRatio", "xMidYMid meet")
      .attr("viewBox", `20 20 ${width * 0.75} ${height * 0.75}`);
    //.attr("viewBox", `210 120 ${width * 0.55} ${height * 0.55}`);
    const markerGroup = svg.append("g");
    const projection = d3.geoOrthographic();
    const initialScale = projection.scale();
    const center = [width / 2, height / 2];
    let path = d3.geoPath().projection(projection);
    let timer, gdistance;
    let totalSignUps = 0;
    const headlineAppendix = document.querySelector(
      ".m-globe__headline__appendix"
    );
    const countriesWithArticle = [
      "FO",
      "FK",
      "AE",
      "AN",
      "BV",
      "CC",
      "CF",
      "CG",
      "CK",
      "CX",
      "DO",
      "CZ",
      "EH",
      "GZ",
      "HM",
      "IM",
      "IO",
      "KY",
      "MH",
      "NF",
      "PH",
      "PN",
      "PS",
      "SB",
      "TC",
      "TF",
      "VG",
      "VI",
      "US",
      "GB",
      "UE",
    ];

    drawGlobe();
    drawGraticule();
    applyInitialRotation();
    enableRotation();
    makeDraggable();
    makeZoomable();
    showGlobe();
    initOverlay();

    function drawGlobe() {
      d3.queue()
        .defer(d3.json, "/assets/globe/world-110m.json")
        .defer(d3.json, "/assets/globe/locations.json")
        .defer(d3.csv, globe.dataset.signUpCsvUrl)
        .await((error, worldData, locationData, signUpData) => {
          svg
            .on("click", function (e) {
              disableRotation();
            })
            .selectAll(".segment")
            .data(
              topojson.feature(worldData, worldData.objects.countries).features
            )
            .enter()
            .append("path")
            .attr("class", "segment")
            .attr("d", path)
            .style("stroke", "#A9DBEB")
            .style("stroke-width", "1px")
            .style("fill", "#FFF")
            .style("display", "block");

          locationData.forEach((location) => {
            if (countriesWithArticle.includes(location.code)) {
              location.name = `the ${location.name}`;
            }
            const signUpDataForCountry = signUpData.find(
              (item) => item.country == location.code
            );
            const countrySignUpCount = signUpDataForCountry
              ? parseInt(signUpDataForCountry.count, 10)
              : 0;
            location.count = countrySignUpCount;
            totalSignUps += countrySignUpCount;
          });
          locations = locationData;

          document.querySelector("#js-globe-participants-total").innerHTML =
            formatNumber(totalSignUps);
          headlineAppendix.style.display = "block";

          drawMarkers();
        });
    }

    function drawGraticule() {
      const graticule = d3.geoGraticule().step([10, 10]);

      svg
        .append("path")
        .datum(graticule)
        .attr("class", "graticule")
        .attr("d", path)
        .style("fill", "#A9DBEB")
        .style("stroke", "#FFF");
      //.style("stroke-dasharray", "4,2");
    }

    function applyInitialRotation() {
      projection.rotate([0, config.verticalTilt, config.horizontalTilt]);
      svg.selectAll("path").attr("d", path);
      drawMarkers();
    }

    function enableRotation() {
      timer = d3.timer(function (elapsed) {
        projection.rotate([
          config.speed * elapsed - 50,
          config.verticalTilt,
          config.horizontalTilt,
        ]);
        svg.selectAll("path").attr("d", path);
        drawMarkers();
      });
    }

    function disableRotation() {
      timer.stop();
      userHasInteracted = true;
    }

    function makeZoomable() {
      d3.select("#js-globe-zoom-plus").on("click", () => {
        disableRotation();
        if (projection.scale() < 1000) {
          projection.scale(projection.scale() * 1.5);
          path = d3.geoPath().projection(projection);
          svg.selectAll("path").attr("d", path);
          drawMarkers();
        }
      });
      d3.select("#js-globe-zoom-minus").on("click", () => {
        disableRotation();
        if (projection.scale() > 200) {
          projection.scale(projection.scale() * 0.5);
          path = d3.geoPath().projection(projection);
          svg.selectAll("path").attr("d", path);
          drawMarkers();
        }
      });

      //svg.call(
      //  d3.zoom().on("zoom", () => {
      //    if (d3.event.transform.k > 0.3) {
      //      projection.scale(initialScale * d3.event.transform.k);
      //      path = d3.geoPath().projection(projection);
      //      svg.selectAll("path").attr("d", path);
      //    } else {
      //      d3.event.transform.k = 0.3;
      //    }
      //    drawMarkers();
      //  })
      //);
    }

    function makeDraggable() {
      svg.call(
        d3.drag().on("drag", (e) => {
          disableRotation();
          const rotate = projection.rotate();
          const k = config.sensitivity / projection.scale();
          projection.rotate([
            rotate[0] + d3.event.dx * k,
            rotate[1] - d3.event.dy * k,
            config.horizontalTilt,
          ]);
          path = d3.geoPath().projection(projection);
          svg.selectAll("path").attr("d", path);
          drawMarkers();
        })
      );
    }

    function drawMarkers() {
      const markers = markerGroup.selectAll("circle").data(locations);
      markers
        .enter()
        .append("circle")
        .merge(markers)
        .attr("cx", (d) => projection([d.longitude, d.latitude])[0])
        .attr("cy", (d) => projection([d.longitude, d.latitude])[1])
        .attr("fill", (d) => {
          const coordinate = [d.longitude, d.latitude];
          const fillColor = d.count > 0 ? "#341CCB" : "white";
          gdistance = d3.geoDistance(coordinate, projection.invert(center));
          return gdistance > 1.57 ? "none" : fillColor;
        })
        .attr("stroke", (d) => {
          const coordinate = [d.longitude, d.latitude];
          gdistance = d3.geoDistance(coordinate, projection.invert(center));
          return gdistance > 1.57 ? "none" : "#341CCB";
        })
        .style("stroke-width", "1px")
        .attr("r", window.innerWidth > 768 ? 5 : 8)
        .on("mouseover", function (countryData) {
          this.setAttribute("r", window.innerWidth > 768 ? 7 : 10);
          if (userHasInteracted) {
            headlineAppendix.innerHTML = getCountryHeadline(countryData);
          }
        })
        .on("mouseout", function () {
          this.setAttribute("r", window.innerWidth > 768 ? 5 : 8);
        })
        .on("click", function (countryData) {
          showOverlay(countryData);
          //const mouse = d3.mouse(this);
          //console.log(Math.round(mouse[0]), Math.round(mouse[1]));
        });

      markerGroup.each(function () {
        this.parentNode.appendChild(this);
      });
    }

    function showGlobe() {
      globe.style.display = "block";
    }

    function getCountryHeadline(country) {
      switch (country.count) {
        case 0:
          return `Be the first participant from ${country.name}!`;
        case 1:
          return `Join one other participant in ${country.name}!`;
        default:
          return `Join ${country.count} participants in ${country.name}!`;
      }
    }

    function initOverlay() {
      overlay
        .querySelector(".m-globe__country-overlay__x")
        .addEventListener("click", (e) => {
          hideOverlay();
        });
      overlay
        .querySelector(".m-globe__country-overlay__shade")
        .addEventListener("click", (e) => {
          hideOverlay();
        });
    }

    function showOverlay(countryData) {
      overlay.querySelector(".m-globe__country-overlay__headline").innerHTML =
        getCountryHeadline(countryData);
      overlay.style.display = "block";
    }

    function hideOverlay() {
      overlay.style.display = "none";
    }

    function formatNumber(number) {
      return new Intl.NumberFormat("en-IN", {
        maximumSignificantDigits: 3,
      }).format(number);
    }
  }
}

export default Globe;
